import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import showConsole from '@/utils/showConsole';

export const useQueryLogger = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const queryCache = queryClient.getQueryCache();
    
    // Log initial state - only in development
    // if (process.env.NODE_ENV === 'development') {
    if (showConsole) {
      console.log('🔧 React Query Logger initialized');
      console.log('📊 Initial query cache:', queryCache.getAll().length, 'queries');
    }

    // Subscribe to cache changes
    const unsubscribe = queryCache.subscribe((event) => {
      // if (process.env.NODE_ENV === 'development') {
      if (showConsole) {
        if (event?.type === 'added') {
          console.log('➕ Query added:', event.query.queryKey);
        } else if (event?.type === 'removed') {
          console.log('➖ Query removed:', event.query.queryKey);
        } else if (event?.type === 'updated') {
          console.log('🔄 Query updated:', event.query.queryKey, 'Status:', event.query.state.status);
        }
      }
    });

    return () => {
      unsubscribe();
      // if (process.env.NODE_ENV === 'development') {
      if (showConsole) {
        console.log('🔧 React Query Logger cleanup');
      }
    };
  }, [queryClient]);

  // Return helper functions for manual debugging
  return {
    logAllQueries: () => {
      const queries = queryClient.getQueryCache().getAll();
      console.table(queries.map(q => ({
        key: JSON.stringify(q.queryKey),
        status: q.state.status,
        fetchStatus: q.state.fetchStatus,
        dataUpdatedAt: new Date(q.state.dataUpdatedAt).toLocaleTimeString(),
        error: q.state.error?.message || 'None'
      })));
    },
    invalidateAll: () => {
      queryClient.invalidateQueries();
      console.log('🔄 All queries invalidated');
    },
    clearAll: () => {
      queryClient.clear();
      console.log('🧹 All queries cleared');
    }
  };
};
